import { Component } from '@angular/core';
import { SectionComponent } from 'src/app/shared/components/section/section.component';
import { CraftCalculatorStateService } from '../craft-calculator-state.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TopItemsService } from 'src/app/services/top-items/top-items.service';
import { SpecLevel } from 'src/app/shared/models/craft-models/specs-models';
import { MatButtonModule } from '@angular/material/button';
import { finalize, take } from 'rxjs';
import { AfmBeService } from 'src/app/services/afm-be/afm-be.service';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ItemImageComponent } from 'src/app/shared/components/item-image/item-image.component';
import { AlbionImageService } from 'src/app/services/albion-image/albion-image.service';

@Component({
  selector: 'app-craft-calculator-specs',
  imports: [SectionComponent, MatFormFieldModule, MatInputModule, FormsModule, MatTooltipModule, MatButtonModule, MatIconModule],
  templateUrl: './craft-calculator-specs.component.html',
  styleUrl: './craft-calculator-specs.component.scss',
})
export class CraftCalculatorSpecsComponent {
  constructor(
    public craftCalculatorStateService: CraftCalculatorStateService,
    private topItemsService: TopItemsService,
    public afmBeService: AfmBeService,
    private snackBar: MatSnackBar,
    public albionImageService: AlbionImageService
  ) {}

  saveSpecs(): void {
    if (!this.afmBeService.userHasMasterpieceEntitlement()) {
      return;
    }

    this.craftCalculatorStateService.isSavingSpecs.set(true);

    const specsLevels: SpecLevel[] = this.craftCalculatorStateService
      .craftGroup()
      .allCraftAchievementsUnique()
      .map((ach) => {
        return {
          spec: ach.id,
          level: ach.playerLevel ?? 0,
        };
      });
    this.topItemsService
      .saveUserSpecs(specsLevels)
      .pipe(
        take(1),
        finalize(() => this.craftCalculatorStateService.isSavingSpecs.set(false))
      )
      .subscribe({
        next: (response) => {
          this.snackBar.open('Saved specs levels', undefined, { duration: 2000 });
        },
        error: (error) => {
          console.error('Error saving specs levels:', error);
          this.snackBar.open('Error saving specs levels', 'Close', { duration: 4000 });
        },
      });
  }
}
